import { Controller } from "@hotwired/stimulus";

/* This is the same as select_and_replace_controller except it doesn't request from server
 * Also the same as customize_message_controller except less specialized
 *
 * @example
 * <div data-controller="select-and-replace-local">
 *   <select data-action="change->select-and-replace-local#handleChange">
 *     <option value=""></option>
 *     <option value="option1" data-content="Content when option 1 is selected">Option 1</option>
 *     <option value="option2" data-content="Content when option 2 is selected">Option 2</option>
 *   </select>
 *   <div data-select-and-replace-local-target="content"></div>
 *
 * As the select changes, the content of the div will be replaced with the
 * data-content value of the option
 *
 * IF you want the "content" target to be populated with the first option's
 * content, specify the "input" target.
 *
 * @example
 * <div data-controller="select-and-replace-local">
 *   <select data-select-and-replace-local-target="input"
 *           data-action="change->select-and-replace-local#handleChange">
 *     <option value="option1" data-content="Content when option 1 is selected">Option 1</option>
 *     <option value="option2" data-content="Content when option 2 is selected">Option 2</option>
 *   </select>
 *   <div data-select-and-replace-local-target="content"></div>
 */
export default class extends Controller {
  static targets = ["content", "input"];

  connect() {
    if (this.hasInputTarget) {
      this.handleChange({ target: this.inputTarget });
    }
  }

  handleChange(event) {
    let selected = event.target.querySelector("option:checked");
    if (selected == null && event.target.dataset.content)
      selected = event.target;
    if (selected == null) return;

    this.contentTargets.forEach((el) => {
      el.innerHTML = selected.dataset.content;
    });
  }
}
